define((require) => {
    "use strict";

    const EditorWebFontController   = require("editor/ui/experience/editor/EditorWebFontController");
    const ExperienceModel           = require("shared/ui/experience/ExperienceModel");
    const FontLoader                = require("shared/util/FontLoader");
    const Promise                   = require("shared/util/Promise");
    const TemplateModel             = require("ui/experience/TemplateModel");

    /**
     * Controller for the editor.
     *
     * @class EditorControllerMixin
     * @constructor
     *
     * @cfg {Region} region The main view region, where the editor view should be rendered.
     */
    return {
        /**
         * Fetches the entire experience including all scenes, widgets and fonts.
         *
         * @param  {String} id The raw experience ID.
         * @return {Promise}   A promise that resolves with the fetched <tt>ExperienceModel</tt>.
         */
        _fetchExperienceAndFonts(id) {
            return this._fetchForModel(id, ExperienceModel, (model) => model);
        },

        /**
         * Fetches the entire template including all meta data and associated experience scenes, widgets and fonts.
         *
         * @param  {String} id The template ID.
         * @return {Promise}   A promise that resolves with the fetched <tt>ExperienceModel</tt>.
         */
        _fetchTemplateExperienceAndFonts(id) {
            return this._fetchForModel(id, TemplateModel, (model) => model.get("content"));
        },

        /**
         * Returns the Experience Model and associated experience fonts.
         *
         * @param id The template or experience ID to retrieve
         * @param model The model with findById
         * @param experienceModelResolver A function that resolve the results of findById to an ExperienceModel
         * @returns {Promise<any>}
         * @private
         */
        _fetchForModel(id, model, experienceModelResolver) {
            let experience;

            return model.findById(id)
                .then((model) => {
                    experience = experienceModelResolver(model);
                    // Make sure all font data is loaded (this may only have an impact initially)
                    // Note: We start fetching font data as soon as the user
                    // signs in (see EditorWebFontController)
                    return EditorWebFontController.promise();
                })
                .then(() => {
                    return Promise.deferred((deferred) => {
                        FontLoader.loadExperienceFonts(experience)
                            .fail((reason) => {
                                const errorMessage = `Failed loading experience fonts for experience with id: ${experience.get("id")}. Reason: ${reason}`;

                                this.options.errorLogger.log(errorMessage);
                            })
                            // We always resolve the experience so it loads,
                            // even if custom fonts fail to load.
                            .always(() => {
                                deferred.resolve(experience);
                            });
                    });
                });
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/EditorControllerMixin.js